import {Component, Vue} from 'vue-property-decorator';
import StepperFlow from '@/services/StepperFlow';
import RoundedButton from '@/components/RoundedButton/RoundedButton.vue';
import {popularKeywords} from '@/constants/config';
import Logger from '@/services/Logger';

@Component({
  components: {RoundedButton},
})
export default class Keywords extends Vue {
  public state = StepperFlow;

  public keyword: string = '';
  public showNoKeywordsDialog = false;
  public showTipDialog = false;
  public popularKeywords = popularKeywords;


  public handleBlur() {

    //console.log("this.keyword ", this.keyword);
    if (this.keyword.length && this.keyword.length > 2) {
      Logger.logKeywordType(this.keyword);
      this.addKeyword(this.keyword);
    }

  }

  public handleKeydown(e: KeyboardEvent) {
    if (e.keyCode === 13) {
      this.addKeywordFromInput(this.keyword);
    }
  }

  public addPopularKeyword(keyword: string) {
    Logger.logAddPopularKeyword(keyword);
    this.addKeyword(keyword);
  }

  public addKeywordFromInput(keyword: string) {
    Logger.logKeywordType(keyword);
    this.addKeyword(keyword);
  }

  public onKeywordDelete(deletedKeyword: string) {
    Logger.logKeywordDelete(deletedKeyword);
    StepperFlow.keywords = StepperFlow.keywords.filter((keyword) => deletedKeyword !== keyword);
  }

  public onErrorCloseClick() {


    var inputElement = document.getElementById("input-keyword");
    if (inputElement) {
      inputElement.focus();
    }


    // console.log("this.$refs.location ", this.$refs.location);
  }


  public submitKeywords() {
    if (!StepperFlow.keywords.length) {
      Logger.logNoKeywordsError();
      this.showNoKeywordsDialog = true;
      return;
    }

    StepperFlow.saveKeywords();

    if (this.$route.query.utm_source == "cmp") {

      const queryParams = new URLSearchParams();
      const {geo = 'us'} = this.$route.query;

      const paramsObj = {
        ...this.$route.query,
        q: StepperFlow.keywords[0] + " jobs",
        utm_source: 'job-flow-cmp',
      } as any;

      Object.keys(paramsObj).forEach((key) => queryParams.set(key, paramsObj[key]));
      var url = `${process.env.VUE_APP_REDIRECT_URL}/?${queryParams}`;
      //var url = `https://nextcareernow.com/results/?${queryParams}`;
      var yahooUrl = `https://nextcareernow.com/results/?${queryParams}`;
      //console.log("yahooUrl ", yahooUrl);
      location.replace(yahooUrl);
      return;
    } else if (this.$route.query.utm_source && this.$route.query.utm_source.search(/job-res/igm) > -1) {

      const queryParams = new URLSearchParams();
      const {geo = 'us'} = this.$route.query;

      const paramsObj = {
        ...this.$route.query,
        tags: StepperFlow.keywords,
        l: localStorage.getItem("formattedLocation") || "",
        utm_source: 'job-flow-cmp',
      } as any;

      Object.keys(paramsObj).forEach((key) => queryParams.set(key, paramsObj[key]));
      var yahooUrl = `https://nextcareernow.com/?${queryParams}`;
      //console.log("yahooUrl ", yahooUrl);
      location.replace(yahooUrl);
      return;
    }

    this.$router.push({path: '/finish', query: this.$route.query});
  }

  private addKeyword(keyword: string) {

    var self = this;
    if (keyword && !StepperFlow.keywords.includes(keyword)) {
      var keywordsArr = [] as string[];
      try {
        keyword = keyword.toLowerCase();
        keywordsArr = keyword.split("/");
        if (keywordsArr.length == 1) {
          keywordsArr = keyword.split(" or ");
        }
      } catch (e) {

      }

      for (var i in keywordsArr) {
        StepperFlow.keywords.push(keywordsArr[i]);
      }


      this.keyword = '';
    }

    if (StepperFlow.keywords.length == 1) {
      this.showTipDialog = true;

      setTimeout(function () {
        //self.showTipDialog = false;
      }, 1000 * 3);
    }

  }
}
